export enum IProjectTypesEnum {
  PRE_SALE = 'PRE_SALE',
  SPEC = 'SPEC',
}

export enum IProjectStatusesEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface IUnviewedItems {
  notifications: number;
  posts: number;
  messages: number;
}

export interface IWeather {
  id: number;
  lat: number;
  lng: number;
  createdAt: string;
  updatedAt: string | null;
  data: {
    daily: {
      dt: number;
      temp: {
        max: number;
        min: number;
      };
      weather: {
        icon: string;
      }[];
    }[];
  };
}

export interface IProjectProfiles {
  id: number;
  userId: number;
  firstName: string;
  lastName: string;
  phone?: string;
  email: string;
  role: string;
  avatar: string | null;
  jobTitle: string;
  isOwner?: boolean;
}
